var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"copy-link",on:{"click":_setup.copyToClipboard}},[(!_setup.isCopy)?_c('img',{attrs:{"src":require("@/assets/img/icons/opportunities/copy.svg"),"alt":"Copy"}}):_vm._e(),(!_setup.isCopy)?_c('span',[_vm._v(" Copiar link ")]):_c('span',[_vm._v(" Copiado! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }